import { render, staticRenderFns } from "./QuestionstypeCopyDelLeft.vue?vue&type=template&id=109c33d8&scoped=true&"
import script from "./QuestionstypeCopyDelLeft.vue?vue&type=script&lang=js&"
export * from "./QuestionstypeCopyDelLeft.vue?vue&type=script&lang=js&"
import style0 from "./QuestionstypeCopyDelLeft.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"
import style1 from "./QuestionstypeCopyDelLeft.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./QuestionstypeCopyDelLeft.vue?vue&type=style&index=2&id=109c33d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109c33d8",
  null
  
)

export default component.exports